<template>
  <div>
    <PageHeader :gradientType="gradientType" />
    <PageContent>
      <template #filterBar>
        <!-- <form @submit.prevent="setFilter"> -->
        <h6 class="heading-small text-muted mb-4">Search</h6>
        <div class="row">
          <div class="col">
            <form @submit.prevent="setFilter">
              <a-input placeholder="Search by" v-model="table.filters.name">
                <a-select
                  slot="addonAfter"
                  default-value="name"
                  style="width: 110px"
                >
                  <a-select-option value="name"> Name </a-select-option>
                </a-select>
              </a-input>
            </form>
          </div>
        </div>

        <hr />
        <h6 class="heading-small text-muted mb-4">Filter by Status</h6>
        <div class="row mb-3">
          <div class="col">
            <a-select
              v-model="table.filters.promo_status"
              mode="multiple"
              style="width: 100%"
              placeholder="Select promotion status"
              @change="setFilter"
            >
              <a-select-option
                v-for="promotionStatus in options.promotionStatuses"
                :value="promotionStatus"
                :key="promotionStatus"
                :label="promotionStatus"
              >
                {{ promotionStatus }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <hr />
        <h6 class="heading-small text-muted mb-4">Filter by Date</h6>
        <div class="row mb-3">
          <div class="col">
            <a-range-picker
              v-model="promoDateRange"
              :default-value="null"
              :format="dateFormat"
              @change="dateRangeOnChange"
              style="width: 100%"
            />
          </div>
        </div>
        <!-- </form> -->
      </template>

      <template #pageTable>
        <PageTable
          :tableTitle="table.title"
          :apiUrl="table.apiUrl"
          :tableFields="table.fields"
          :appendedParams="table.filters"
          :httpOptions="table.httpOptions"
          :sortOrder="table.sortOrder"
        >
          <template #headerButtons>
            <base-button
              id="new"
              class="float-right ml-1"
              type="primary"
              size="sm"
              v-if="selectedActions.includes('Add')"
              @click="openDrawer()"
              >+ Create Promotion</base-button
            >
          </template>

          <template #formDrawer>
            <a-drawer
              :width="drawer.width"
              :placement="drawer.placement"
              :visible="drawer.visible"
              @close="closeDrawer"
            >
              <PromotionForm
                :viewMode="viewMode"
                :promotionData="promotionData"
                :systemModules="systemModules"
                @closeDrawer="closeDrawer"
              />
            </a-drawer>
          </template>

          <template #tableButtons="{ tableProps }">
            <button
              id="view"
              v-if="selectedActions.includes('View')"
              class="btn btn-success btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              View
            </button>

            <button
              id="edit"
              v-if="selectedActions.includes('Edit')"
              class="btn btn-warning btn-sm"
              @click.prevent="openDrawer(tableProps.rowData)"
            >
              Edit
            </button>
          </template>

          <template #customComponent="{ tableProps }">
            <div class="text-center">
              <a-tag
                v-if="tableProps.rowData.promo_status == 'Active'"
                color="#2db7f5"
              >
                {{ tableProps.rowData.promo_status.toUpperCase() }}
              </a-tag>

              <a-tag
                v-if="tableProps.rowData.promo_status == 'Not Started'"
                color="#FFC55C"
              >
                {{ tableProps.rowData.promo_status.toUpperCase() }}
              </a-tag>

              <a-tag
                v-if="tableProps.rowData.promo_status == 'Completed'"
                color="#87d068"
              >
                {{ tableProps.rowData.promo_status.toUpperCase() }}
              </a-tag>

              <a-tag
                v-if="tableProps.rowData.promo_status == 'Archived'"
                color="#f50"
              >
                {{ tableProps.rowData.promo_status.toUpperCase() }}
              </a-tag>
            </div>
          </template>
        </PageTable>
      </template>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '../../components/Page/Header.vue';
import PageContent from '../../components/Page/Content.vue';
import PageTable from '../../components/Page/Table.vue';
import PromotionForm from './PromotionForm.vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import secureStorage from '../../controllers/secureStorage';
import tokenHandler from '../../controllers/token';

const PromotionAPI = process.env.VUE_APP_PROMOTION_API;

export default {
  components: {
    PageHeader,
    PageContent,
    PageTable,
    PromotionForm
  },
  data() {
    return {
      gradientType: 'gradient-blue',
      promotionData: null,
      systemModules: null,
      promoDateRange: null,
      dateFormat: 'YYYY-MM-DD',
      drawer: {
        visible: false,
        width: 800,
        placement: 'right'
      },
      viewMode: false,
      table: {
        title: 'Promotions',
        apiUrl: PromotionAPI + '/promotions',
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem('promotionToken')
          }
        },
        fields: [
          'actions',
          { name: 'name', title: 'Name' },
          // { name: 'promo_status', title: 'Status' },
          { name: 'custom-slot', title: 'Status' },
          {
            name: 'start_date',
            title: 'Start Date',
            formatter(date) {
              if (moment(date).isValid()) {
                return moment(date).format('MM/DD/YYYY');
              }
              return null;
            }
          },
          {
            name: 'end_date',
            title: 'End Date',
            formatter(date) {
              if (moment(date).isValid()) {
                return moment(date).format('MM/DD/YYYY');
              }
              return null;
            }
          },
          {
            name: 'created_at',
            title: 'Created Date',
            formatter(date) {
              if (moment(date).isValid()) {
                return moment(date).format('MM/DD/YYYY');
              }
              return null;
            }
          },
          {
            name: 'user.name',
            title: 'Created By'
          }
        ],
        sortOrder: [
          {
            field: 'id',
            direction: 'desc'
          }
        ],
        filters: {
          name: null,
          promo_status: ['Active', 'Not Started'],
          promo_from: null,
          promo_to: null
        }
      },

      options: {
        promotionStatuses: ['Active', 'Not Started', 'Completed', 'Archived']
      },

      radio: {
        style: {
          display: 'block',
          height: '35px',
          lineHeight: '30px'
        }
      }
    };
  },
  methods: {
    async openDrawer(rowData = null) {
      this.promotionData = rowData;

      this.viewMode = event.target.id == 'view' ? true : false;
      this.drawer.visible = true;
    },

    dateRangeOnChange(dateObj, dateString) {
      this.promoDateRange = dateString;
      this.table.filters.promo_from = dateString[0] ?? null;
      this.table.filters.promo_to = dateString[1] ?? null;
      console.log('dateObj: ', dateObj);

      this.setFilter();
    },

    closeDrawer() {
      this.drawer.visible = false;
      this.promotionData = null;
    },

    setFilter() {
      this.$root.$emit('refreshTable');
    }
  },

  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    })
  },

  created() {
    this.$store.dispatch('setCurrentModule', 'Promotion');
  },

  async mounted() {
    if (secureStorage.getItem('uploadToken') === null) {
      await tokenHandler.refreshS3Token();
    }
  }
};
</script>

<style scoped></style>
